import * as Colors from 'material-ui/styles/colors';
import { LEFT_BAR_COLLAPSED_WIDTH, LEFT_BAR_EXPANDED_WIDTH, LEFT_BAR_BACKGROUND_COLOR, LEFT_BAR_ACTIVE_COLOR } from '../EditorLeftBarStyles';

const menuElementWrapper = {
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: '50px',
};

export default {
  menuElementWrapper,
  menuElementWrapperResponsive: {
    width: LEFT_BAR_COLLAPSED_WIDTH,
    ...menuElementWrapper,
    '@media (max-height: 710px)': {
      height: '42px',
    },
    '@media (min-width: 1366px)': {
      width: LEFT_BAR_EXPANDED_WIDTH
    },
  },
  menuElementLabel: {
    color: Colors.grey200,
    fontSize: '14px',
    fontWeight: '400',
    paddingRight: 0,
    whiteSpace: 'nowrap',
  },
  menuElementButton: {
    height: '100%',
    width: '100%',
    color: Colors.grey200,
    textAlign: 'left',
    minWidth: 'auto',
    borderRadius: 0,
    lineHeight: '50px',
    zIndex: 0,
  },
  menuElementButtonActive: {
    backgroundColor: LEFT_BAR_ACTIVE_COLOR,
  },
};
